module.exports = __webpack_public_path__ + "img/flag_tr.d2303f9.png";